import {QUESTION_TYPE} from './question.type.model';

/**
 * Questions dont la réponse est une note, donnée sur une suite de crans : les indicateurs, dont
 * l'échelle est imposée par l'analyse, et l'échelle d'évaluation, dont les bornes se règlent.
 *
 * Ce sont les seules que la carte dessine encadrées de leurs deux bornes.
 */
export const RATED_QUESTION_TYPES: QUESTION_TYPE[] = [
    QUESTION_TYPE.NPS,
    QUESTION_TYPE.CES,
    QUESTION_TYPE.CSAT,
    QUESTION_TYPE.MONO_CSAT,
    QUESTION_TYPE.MULTI_CSAT,
    QUESTION_TYPE.SCALE,
];
